export function createPOIListImage(data: any, paid = false) {
	const image = Mapy.Util.node("div", { className: "ui-poilistimage" }) as HTMLDivElement;
	const imageData = Mapy.Util.getImageData(data, paid);

	// booking
	if (imageData.booking) {
		const bookingImg = Mapy.Util.node("img") as HTMLImageElement;

		bookingImg.classList.add("landscape");
		bookingImg.addEventListener("load", function onLoad() {
			// rozmery rodice
			const pW = 80;
			const pH = 80;
			const width = bookingImg.naturalWidth;
			const height = bookingImg.naturalHeight;
			// spocitame novou sirku
			const cW = pH * width / height;

			if (cW < pW) {
				bookingImg.classList.remove("landscape");
				bookingImg.classList.add("portrait");
			}
		});
		bookingImg.src = imageData.booking;
		bookingImg.crossOrigin = "anonymous";
		image.appendChild(bookingImg);
	} else {
		if (imageData.icon) {
			image.classList.add("icon");
		}

		if (imageData.small) {
			image.classList.add("small");
		}

		if (imageData.favicon) {
			image.classList.add("favicon");
		}

		if (imageData.universal) {
			image.classList.add("universal");
		}

		image.appendChild(Mapy.Util.node("img", { src: imageData.url, srcset: `${imageData.url} 1x, ${imageData.url2x} 2x`, crossOrigin: "anonymous" }));
	}

	return image;
}
